/**
 * Support pane for portal settings — admin-provided support email + help center
 * links. Only rendered when branding supplies at least one of them.
 */
import { ExternalLink } from "lucide-react";
import { Label } from "@ddmarc/ui";
import { useBranding } from "@/lib/branding-context";
import { CardV2 } from "@/components/primitives";

export function SupportPane() {
  const { branding } = useBranding();
  return (
    <CardV2
      title="Support"
      subtitle="Get help from your administrator."
    >
      <div className="space-y-3">
        {branding?.support_email && (
          <div className="space-y-1">
            <Label className="text-[10.5px] font-semibold uppercase tracking-[0.05em] text-[var(--v2-fg-subtle)]">
              Email
            </Label>
            <p>
              <a
                href={`mailto:${branding.support_email}`}
                className="text-[13px] font-medium text-[var(--color-primary)] hover:underline"
              >
                {branding.support_email}
              </a>
            </p>
          </div>
        )}
        {branding?.support_url && (
          <div className="space-y-1">
            <Label className="text-[10.5px] font-semibold uppercase tracking-[0.05em] text-[var(--v2-fg-subtle)]">
              Help center
            </Label>
            <p>
              <a
                href={branding.support_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-[13px] font-medium text-[var(--color-primary)] hover:underline"
              >
                {branding.support_url}
                <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </p>
          </div>
        )}
      </div>
    </CardV2>
  );
}
